import { useEffect, useState } from "react";
import { Box, Button, CircularProgress, CssBaseline, Grid, Typography } from "@mui/material";
import MetaDecorator from "../../services/meta_decorator";
import { Redirect, useParams } from "react-router-dom";
import { getApiUrl } from "../../services/api_service";
import Footer from "../../components/shared/footer";
import { bodyBg, footerContainer, fullHeight, headerText, orangecolor, rcolor, registrationHeader, whitecolor } from "../../style2";

export default function SplashPage() {
    const [error, setError] = useState('');
    const [appFound, setAppFound] = useState(null);
    const [loading, setLoading] = useState(false);
    const [content, setContent] = useState(null);
    const [redirect, setRedirect] = useState('');
    const { orgCode } = useParams();

    useEffect(() => {
        setError('');
        setLoading(true);
        fetch(`${getApiUrl()}/ReferralApp/splash?code=${orgCode}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                if (response.status === 200) {
                    setAppFound(true);
                    response.json().then(data => {
                        setContent(data.splash);
                    });
                }
                else {
                    setAppFound(false);
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server. Please check your internet connection.");
            }).finally(() => {
                setLoading(false);
            })
    }, [orgCode]);

    if (redirect !== "")
        return <Redirect to={redirect} />;
    else
        return <Box sx={{ ...bodyBg, ...fullHeight }}>
            <CssBaseline />
            <MetaDecorator title={"EnrichMyCare - Referral"} description={"EnrichMycare Refferal"} />
            <Box sx={{ background: whitecolor, padding: 1, height: "100vh" }}>
                <Grid container>
                    <Grid item xs={6}>
                        <img style={{ maxHeight: 100 }} src='../derbyshireNHSTrust.png' alt='Derbyshire Healthcare NHS Foundation Trust' />
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: "right" }} >
                        <Box sx={{ paddingTop: 1 }}>
                            <Box component="img" sx={registrationHeader} src='../Logo_Option_1.svg' alt='logo' />
                        </Box>
                    </Grid>
                </Grid>
                <Box>
                    {loading ? <Box p={5} sx={{ textAlign: "center" }}><CircularProgress /></Box> : null}
                    {error !== "" ? <Box mt={1} mb={2} sx={{ color: rcolor, textAlign: "center", padding: "5rem 0px", fontSize: "2rem", fontWeight: "bold", lineHeight: 1.5 }}>{error}</Box> : null}
                    {content !== "" ? <Typography dangerouslySetInnerHTML={{ __html: content }} variant="h3" sx={{...headerText, padding: "5rem 0px", fontSize: "3rem", fontWeight: "bold", lineHeight: 1.5, textAlign: "center" }}></Typography> : null}
                </Box>
                <Box sx={{ textAlign: "center" }}>
                    {appFound ? <Button disabled={loading} onClick={() => { setRedirect(`/referral/information/${orgCode}`) }}
                        style={{ background: orangecolor, borderRadius: 15, width: "150px", color: whitecolor, textTransform: "capitalize", fontSize: "1.3rem", height: "50px" }}>Proceed</Button> : null}
                </Box>
            </Box>
            <Box sx={footerContainer}>
                <Footer />
            </Box>
        </Box>;
}